import { render, staticRenderFns } from "./StoreProfileLogo.vue?vue&type=template&id=276bece6&"
import script from "./StoreProfileLogo.vue?vue&type=script&lang=js&"
export * from "./StoreProfileLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports